export enum DATE_FORMAT_STRING {
  MM_dd_yyyy = 'MM/dd/yyyy',
  yyyy_MM_dd = 'yyyy-MM-dd',
  MMM_dd = 'MMM dd',
  DAY_OF_WEEK_SHORT = 'E',
  DAY_OF_MONTH = 'dd',
  DAY_OF_WEEK = 'EEEE',
  E_MMMM_do_yyyy = 'E, MMMM do yyyy',
  do_MMMM_yyyy = 'do MMMM yyyy',
  MMMM_yyyy = 'MMMM yyyy',
  MM_dd_yy = 'MM/dd/yy',
  yyyy_MM_dd2 = 'yyyy/MM/dd',
  MM_dd_yyyy2 = 'MM-dd-yyyy',
  YEAR = 'y',
  E_MMMM_do = 'E, MMMM do',
  E_MMM_d = 'E, MMM d',
  EEE_MMMM_do_yyyy = 'EEE, MMMM do yyyy',
  EEEE_MMMM_do = 'EEEE, MMMM do',
}

export enum TIME_FORMAT_STRING {
  HH_mm_aaa = 'HH:mm aaa',
  h_mma = 'h:mma',
  h_mm_aaa = 'h:mm aaa',
  h_mm_aaa2 = 'h:mmaaa',
  hh_mm_a = 'hh:mm a',
  h_mm_a = 'h:mm a',
  HH_mm = 'HH:mm',
  LONG_LOCALIZED_TIME = 'p',
}

export enum DATE_AND_TIME_FORMAT_STRING {
  MM_dd_yyyy_hh_mm_a = 'MM/dd/yyyy hh:mm a',
  MMM_d_yyyy_h_mm_a = 'MMM d, yyyy h:mm a',
  MM_dd_yyyy_h_mm_a = 'MM/dd/yyyy h:mm a',
  MM_dd_yyyy_h_mm_aaa = 'MM/dd/yyyy h:mm aaa',
}

export const NOTIFICATION_SENT_AT_FORMAT = 'MM/dd/yyyy hh:mm:ss a'

export const SHIFT_DATE_FORMAT = 'MM/dd/yyyy'
export const SHIFT_TIME_FORMAT = 'MM/dd/yyyy hh:mm:ss a'

export const TIMESHEET_TIMESTAMP_FORMAT = 'MM/dd/yyyy hh:mm a'
export const TIMESHEET_TIMESTAMP_FULL_FORMAT = 'MM/dd/yyyy hh:mm:ss a'
